"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = require("react-emotion");

var _styleConsts = require("../utils/styleConsts");

var header = function header(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;justify-content:space-between;padding-bottom:8px;font-size:18px;font-weight:", _styleConsts.font.weight.bold, ";border-bottom:1px solid ", theme.color.grey2, ";fill:", theme.color.black3, ";")
  );
};

var main = function main(theme, title) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("padding:8px 0;padding-top:", !title ? '0px' : '', ";font-size:", _styleConsts.font.size.large, ";color:", theme.color.black2, ";")
  );
};

var footer = function footer() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;justify-content:flex-end;align-items:center;button{margin-left:16px;}")
  );
};

var _default = {
  header: header,
  main: main,
  footer: footer
};
exports.default = _default;